import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Constants } from './app/common';
import { ensureCurrentDeployment } from './app/services/deployment-version/deployment-version.service';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: Constants.dateFormat,
    timeInput: null,
  },
  display: {
    dateInput: Constants.dateFormat,
    timeInput: { hour: 'numeric', minute: '2-digit' },
    timeOptionLabel: { hour: 'numeric', minute: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

async function startApplication(): Promise<void> {
  if (!await ensureCurrentDeployment()) return;
  await bootstrapApplication(AppComponent, appConfig);
}

startApplication().catch((err) => console.error(err));
